/* type/value/is.js */ function _(require, module, exports) {
    // ES3 safe
    var _undefined = void 0;
    module.exports = function (value) { return value !== _undefined && value !== null; };
}
